// import moment from "moment";
import Vue from "vue";
import Formatter from "@/hive/Formatter";

Vue.filter("mobile", number => {
  return Formatter.mobileDisplay(number);
});
Vue.filter("fullName", function(data) {
  let n = data.name;
  if (data.midName) {
    n += " " + data.midName;
  }
  if (data.surname) {
    n += " " + data.surname;
  }
  return n;
});

Vue.filter("fullNameShort", function(data) {
  let n = data.name;
  if (data.surname) {
    n += "." + data.surname.substr(0, 1).toUpperCase();
  }
  return n;
});
